import * as yup from "yup";
export const schema = yup.object({
  code: yup.string().required("Mã hồ sơ hoặc Căn cước công dân bắt buộc phải nhập"),
  password: yup.string().required("Mật khẩu tra cứu bắt buộc phải nhập"),
});
export const schemaKetQua = yup.object({
  code: yup.string().required("Mã hồ sơ hoặc Căn cước công dân bắt buộc phải nhập"),
});
const pattern = /^[0-9]{8}$|^[0-9]{12}$/
export const schemaNhapHoc = yup.object({
  query: yup
  .string()
  .required("CCCD hoặc số báo danh bắt buộc phải nhập")
  .matches(pattern, "CCCD hoặc số báo danh không đúng định dạng"),
});
